<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.2" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.14" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />

<app-navbar></app-navbar>

<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
<a href="https://wa.me/543462583388" class="float" target="_blank">
<i class="fa fa-whatsapp my-float"></i>
</a>
<!-- Header -->
<div class="header">
    <drag-scroll *ngIf="slider.length > 0" #headerCarousel drag-scroll-y-disabled="true" scrollbar-hidden="true">
        <div drag-scroll-item *ngFor="let item of slider" (click)="clickSlider(item)">
            <img [src]="item.url_image" [alt]="item.alt_image" />
        </div>
    </drag-scroll>
    <button mat-button (click)="moveLeft()" style="left: -20px; padding-left: 28px;"><i class="jam jam-chevron-left"></i></button>
    <button mat-button (click)="moveRight()" style="right: -20px; padding-right: 28px;"><i class="jam jam-chevron-right"></i></button>
</div>


<!-- Bar Benefits -->
<div class="bar-benefits">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start">
        <div style="width: 100%;">

            <div class="bar-benefits-content">
                <div class="item">
                    <div class="icon">
                        <span class="jam jam-coin"></span>
                    </div>
                    <div class="text">
                        <h5>Pagá en 3 y 6 cuotas</h5>
                        <p><small>Usando tu tarjeta MUTUALCARD</small></p>
                    </div>
                </div>

                <div class="separate-line"></div>
            <a href="https://wa.me/543462583388">
                <div class="item">
                    <div class="icon">
                        <span class="jam jam-whatsapp"></span>
                    </div>
                    <div class="text">
                        <h5>Comunicación Directa</h5>
                        <p><small>Estamos para ayudarte 3462-583388</small></p>
                    </div>
                </div>
            </a>

                <div class="separate-line"></div>

                <div class="item">
                    <div class="icon">
                        <span class="jam jam-car"></span>
                    </div>
                    <div class="text">
                        <h5>Retirá gratis tus compras</h5>
                        <p><small>En cualquiera de nuestras sucursales</small></p>
                    </div>
                </div>
            </div>

            <!-- <div class="item">
                <div class="icon">
                    <span class="jam jam-coin"></span>
                </div>
                <div class="text">
                    <h5>30 días de prueba</h5>
                    <p><small>o te devolvemos el producto</small></p>
                </div>
            </div> -->
        </div>
    </div>
</div>


<!-- Block Promo -->
<div *ngIf="featuredCategories.length > 0" class="block-promo" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1200px" fxFlex.lt-lg="90%" fxLayoutGap="30px">
        <div fxFlex="50%">
            <div class="promo" fxLayout="row">
                <div class="texts" fxFlex="50%" fxFlexAlign="center start">
                    <a [href]="featuredCategories[0].url_category" class="link hover-linear">
                        <p><small>{{featuredCategories[0].title_category}}</small></p>
                    </a>
                    <h2 style="font-size:20px !important; font-weight: bolder;" (click)="onClickLink(featuredCategories[0].url_product)">{{featuredCategories[0].title_product}}</h2>
                    <button mat-button (click)="onClickLink(featuredCategories[0].url_action)">{{featuredCategories[0].title_action}}</button>
                </div>
                <div class="img-product" fxFlex="50%">
                    <img [src]="featuredCategories[0].image_product" />
                </div>
            </div>
        </div>
        <div fxFlex="50%">
            <div class="promo" fxLayout="row">
                <div class="texts" fxFlex="50%">
                    <a [href]="[featuredCategories[1].url_category]" class="link hover-linear">
                        <p><small>{{featuredCategories[1].title_category}}</small></p>
                    </a>
                    <h2 style="font-size:20px !important; font-weight: bolder;" (click)="onClickLink(featuredCategories[1].url_product)">{{featuredCategories[1].title_product}}</h2>
                    <button mat-button (click)="onClickLink(featuredCategories[1].url_action)">{{featuredCategories[1].title_action}}</button>
                </div>
                <div class="img-product" fxFlex="50%">
                    <img [src]="featuredCategories[1].image_product" />
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Offert Products Slide -->
<div *ngIf="offertProducts.length > 0" class="offert-products">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start">
        <div style="width: 100%;" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
            <h2 class="title">Productos en Ofertas Semanales</h2>
            <hr>
        </div>
    </div>
   
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start">
        <div style="width: 100%;" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
            <div class="row-slide" dynamicHeight>
                <div class="item-offert" *ngFor="let product of offertProducts" [routerLink]="['/producto/' + product.id + '/' + processProductTitle(product)]">
                    <img [src]="product.photo_feature" [alt]="product.title"/>
                    <h3 class="product-name">{{product.title}}</h3>
                    <h4><span>{{ getPriceWithoutDiscount(product) | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</span> &nbsp; {{ getPrice(product) | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</h4>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Products Tabs -->
<div class="products-tabs">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start">
        <div style="width: 100%;" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
            <h2 class="title">Destacados</h2>

            <mat-tab-group mat-align-tabs="end" dynamicHeight>
                <mat-tab label="En Venta">
                    <ng-template matTabContent>
                        <app-product-card *ngFor="let item of productsFeatured.data" [product]="item"></app-product-card>
                    </ng-template>
                </mat-tab>

                <!--<mat-tab label="Más Vendidos">
                    <ng-template matTabContent>
                        <app-product-card *ngFor="let item of productsSells.data" [product]="item"></app-product-card>
                    </ng-template>
                </mat-tab>

                <mat-tab label="Populares">
                    <ng-template matTabContent>
                        <app-product-card *ngFor="let item of productsViews.data" [product]="item"></app-product-card>
                    </ng-template>
                </mat-tab>-->
            </mat-tab-group>
        </div>
    </div>
</div>


<!-- Bar Benefits Items -->
<div class="bar-benefits-items" fxLayoutAlign="center start" fxHide.xs fxHide.sm>
    <div fxLayout="row" fxLayout.xs="column" fxFlex="1100px" fxFlex.md="90%" fxLayoutGap="30px">
        <div fxFlex="33%">
            <div class="item-benefit">
                <div class="img-container"><img src="/assets/img/icon-offert.svg" width="80px" /></div>
                <h3>Pagá con tarjeta o en efectivo</h3>
                <p><small>Elegí el medio de pago y aprovecha nuestras promociones exclusivas</small></p>
            </div>
        </div>
        <div fxFlex="33%">
            <div class="item-benefit">
                <div class="img-container"><img src="/assets/img/icon-whatsapp.svg" width="70px" /></div>
                <h3>Atención personalizada</h3>
                <p><small>Escribinos al Whatsapp 3462-583388</small></p>
            </div>
        </div>
        <div fxFlex="33%">
            <div class="item-benefit">
                <div class="img-container"><img src="/assets/img/icon-like.svg" width="90px" /></div>
                <h3>Servicio post venta</h3>
                <p><small>Comunicate al (03462) 427715 - 421821. Estamos para ayudarte</small></p>
            </div>
        </div>
    </div>
</div>


<!-- Bar Benefits Items Only mobile -->
<div class="bar-benefits-items mobile" fxHide fxShow.xs fxShow.sm>
    <div fxLayout.xs="row" fxLayoutAlign="center start">
        <div fxFlex="80%">
            <!-- <mat-carousel timings="500ms ease" interval="5000" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="false" slides="3">
                <mat-carousel-slide>
                    <div class="item-benefit">
                        <div class="img-container"><img src="/assets/img/icon-offert.svg" width="80px" alt="Item Benefit One" />
                        </div>
                        <h3>Pagá con tarjeta o en efectivo</h3>
                        <p><small>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat, pariatur quasi iure
                                molestias
                                fugiat expedita.</small></p>
                    </div>
                </mat-carousel-slide>
                <mat-carousel-slide>
                    <div class="item-benefit">
                        <div class="img-container"><img src="/assets/img/icon-bus.svg" width="120px" alt="Item Benefit One" />
                        </div>
                        <h3>Envío gratis desde $ 1.999</h3>
                        <p><small>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat, pariatur quasi iure
                                molestias
                                fugiat expedita.</small></p>
                    </div>
                </mat-carousel-slide>
                <mat-carousel-slide>
                    <div class="item-benefit">
                        <div class="img-container"><img src="/assets/img/icon-like.svg" width="90px" alt="Item Benefit One" />
                        </div>
                        <h3>Seguridad, de principio a fin</h3>
                        <p><small>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat, pariatur quasi iure
                                molestias
                                fugiat expedita.</small></p>
                    </div>
                </mat-carousel-slide>
            </mat-carousel> -->

            <drag-scroll #itemBenefits drag-scroll-y-disabled="true" scrollbar-hidden="true">

                <div drag-scroll-item style="width: 100%; margin: 0 !important;">
                    <div class="item-benefit">
                        <div class="img-container"><img src="/assets/img/icon-offert.svg" width="80px" alt="Item Benefit One" /></div>
                        <h3>Pagá con tarjeta o en efectivo</h3>
                        <p><small>Elegí el medio de pago y aprovecha nuestras promociones exclusivas</small></p>
                    </div>
                </div>

                <div drag-scroll-item style="width: 100%; margin: 0 !important;">
                    <div class="item-benefit">
                        <div class="img-container"><img src="/assets/img/icon-bus.svg" width="120px" alt="Item Benefit One" /></div>
                        <h3>Atención personalizada</h3>
                        <p><small>Escribinos al Whatsapp 3462-583388</small></p>
                    </div>
                </div>

                <div drag-scroll-item style="width: 100%; margin: 0 !important;">
                    <div class="item-benefit">
                        <div class="img-container"><img src="/assets/img/icon-like.svg" width="90px" alt="Item Benefit One" />
                        </div>
                        <h3>Servicio post venta</h3>
                        <p><small>Comunicate al (03462) 427715 - 421821. Estamos para ayudarte</small></p>
                    </div>
                </div>

            </drag-scroll>
        </div>
    </div>
</div>


<!-- Separate Bar Promo -->
<app-separate-bar-promo></app-separate-bar-promo>


<!-- Best Categories -->
<div class="best-categories">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.lt-lg="90%">
            <h2 class="title">Mejores Categorías</h2>
            <hr>
        </div>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.lt-lg="90%">
            <div class="card" *ngFor="let item of bestCategories" [routerLink]="['/buscar/categoria/'+ item.id +'/' + item.title]">
                <img [src]="item.photo" alt="{{ item.title }}" />
                <h6></h6>
                <h2>{{ item.title }}</h2>
            </div>
        </div>
    </div>
</div>





<app-footer></app-footer>
